module.exports = __webpack_public_path__ + "static/media/NZ.5ca250fe.svg";